var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { format, parseISO } from 'date-fns';
import formatCurrency from 'syf-js-utilities/formats/formatCurrency';
import i18n from '../strings/i18n';
import { getNumberOfDaysToScheduledPayment, numberOfDaysToDueDate } from './activityHelpers';
export var pastDueStatus = function (isPayLaterAccount) { return (__assign(__assign({ name: 'pastDueNotify', description: i18n({ notifications: 'pastDueNotify' }) }, (!isPayLaterAccount && {
    subDescription: i18n({ notifications: 'pastDueNotifyMessage' })
})), { notificationType: 'warning', notificationIcon: 'exclamation-triangle' })); };
export var currentPaymentDueStatus = function () { return ({
    name: 'paymentDueTodayNotify',
    description: i18n({ notifications: 'paymentDueTodayNotify' }),
    notificationType: 'warning',
    notificationIcon: 'exclamation-triangle'
}); };
export var futurePaymentDueStatus = function (date) {
    var daysToDueDate = numberOfDaysToDueDate(date);
    var name = daysToDueDate === 1 ? 'paymentDueTomorrowNotify' : 'paymentDueFutureNotify';
    return {
        name: name,
        description: i18n({ notifications: name }, {
            numberOfDaysToDueDate: daysToDueDate
        }),
        notificationType: 'info',
        notificationIcon: 'calendar-day'
    };
};
var getScheduledPaymentStatusName = function (daysToDueDate) {
    switch (daysToDueDate) {
        case 0:
            return 'paymentScheduledTodayNotify';
        case 1:
            return 'paymentScheduledTomorrowNotify';
        default:
            return 'paymentScheduledFutureNotify';
    }
};
export var paymentScheduledStatus = function (activity, daysToDueDate, isPayLaterAccount) {
    var payAmount = Math.abs(Number(activity === null || activity === void 0 ? void 0 : activity.amount));
    var name = !isPayLaterAccount
        ? getScheduledPaymentStatusName(daysToDueDate)
        : 'paymentScheduledFutureNotify';
    return {
        name: name,
        description: i18n({ notifications: name }, {
            payAmount: formatCurrency(payAmount),
            numberOfDaysToDueDate: daysToDueDate
        }),
        notificationType: 'success',
        notificationIcon: 'calendar-day'
    };
};
export var noPaymentDueStatus = function () { return ({
    name: 'noPaymentDueNotify',
    description: i18n({ notifications: 'noPaymentDueNotify' }),
    notificationType: 'success',
    notificationIcon: 'check'
}); };
var getAutoPaymentStatusName = function (daysToDueDate) {
    switch (daysToDueDate) {
        case 0:
            return 'autopayTodayNotify';
        case 1:
            return 'autopayTomorrowNotify';
        default:
            return 'autopayFutureNotify';
    }
};
export var autopayScheduledStatus = function (amount, daysToDueDate) {
    var minAmountDue = Math.abs(Number(amount));
    var name = getAutoPaymentStatusName(daysToDueDate);
    return {
        name: name,
        description: i18n({
            notifications: name
        }, {
            minAmountDue: formatCurrency(minAmountDue),
            daysToDueDate: daysToDueDate
        }),
        notificationType: 'success',
        notificationIcon: 'sync'
    };
};
export var getScheduledPaymentStatus = function (scheduledActivities, isPayLaterAccount) {
    return scheduledActivities
        ? scheduledActivities.map(function (activity) {
            var daysToDueDate = getNumberOfDaysToScheduledPayment(activity);
            if (daysToDueDate >= 0) {
                return paymentScheduledStatus(activity, daysToDueDate, isPayLaterAccount);
            }
            return null;
        })
        : [];
};
export var getPaymentProcessingStatus = function (processingActivities) {
    return processingActivities.map(function (_a) {
        var amount = _a.amount;
        return {
            name: 'paymentProcessingNotify',
            description: i18n({
                notifications: 'paymentProcessingNotify'
            }, {
                amountPaid: formatCurrency(Math.abs(Number(amount)))
            }),
            notificationType: 'info',
            notificationIcon: 'spinner'
        };
    });
};
export var loanPaidOffStatus = function () { return ({
    name: 'loanPaidOffNotify',
    description: i18n({ notifications: 'loanPaidOffNotify' }),
    notificationType: 'success',
    notificationIcon: 'check'
}); };
export var registerAccountStatus = function () { return ({
    name: 'registerAccountNotify',
    description: i18n({ notifications: 'registerAccountNotify' }),
    notificationType: 'warning',
    notificationIcon: 'exclamation-triangle'
}); };
export var enrolledOnPaymentPlanStatus = function () { return ({
    name: 'enrolledPaymentPlan',
    description: i18n({ notifications: 'enrolledPaymentPlan' }),
    notificationType: 'success',
    notificationIcon: 'check'
}); };
export var closedWithBalanceStatus = function () { return ({
    name: 'closedWithBalanceNotify',
    description: i18n({ notifications: 'closedWithBalance' }),
    notificationType: 'info',
    notificationIcon: 'store-alt-slash'
}); };
export var attentionRequiredStatus = function () { return ({
    name: 'attentionRequiredNotify',
    description: i18n({ notifications: 'attentionRequired' }),
    subDescription: "".concat(i18n({ notifications: 'issueWithAccount' }), " \n   "),
    notificationType: 'warning',
    notificationIcon: 'exclamation-triangle'
}); };
export var waivedInterestExpiringNotification = function (waivedInterest) {
    var promoEndDate = format(parseISO(waivedInterest === null || waivedInterest === void 0 ? void 0 : waivedInterest.promoEndDate), 'MM-dd-yyyy');
    return {
        name: 'waivedInterestExpiringNotify',
        description: i18n({ notifications: 'promotionExpiring' }),
        subDescription: i18n({ notifications: 'waivedInterestPromotionExpiring' }, {
            payOffBalance: waivedInterest === null || waivedInterest === void 0 ? void 0 : waivedInterest.payOffBalance,
            promoEndDate: promoEndDate
        }),
        notificationType: 'warning',
        notificationIcon: 'exclamation-triangle'
    };
};
export var waivedInterestExpiredNotification = function () { return ({
    name: 'waivedInterestExpiredNotify',
    description: i18n({ notifications: 'promotionExpired' }),
    subDescription: i18n({ notifications: 'waivedInterestPromotionExpired' }),
    notificationType: 'warning',
    notificationIcon: 'exclamation-triangle'
}); };
